<template>
    <div class="home__awards">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="bg">
                        <h5 class="title text-center">
                            {{ $t("promo.Awards - h5") }}
                        </h5>
                        <p class="text-center">
                            {{ $t("promo.Awards - h5 - subheading") }}
                        </p>
                        <div
                            class="awards d-flex flex-wrap flex-lg-nowrap justify-content-center justify-content-lg-between"
                        >
                            <div class="item">
                                <img src="/images/promo/award_1.png" alt="" />
                            </div>

                            <div class="item">
                                <img src="/images/promo/award_2.png" alt="" />
                            </div>
                            <div class="item">
                                <img src="/images/promo/award_3.png" alt="" />
                            </div>
                            <div class="item">
                                <img src="/images/promo/award_4.png" alt="" />
                            </div>
                            <div class="item">
                                <img src="/images/promo/award_5.png" alt="" />
                            </div>
                        </div>
                        <div
                            class="video d-flex align-items-center justify-content-center"
                            :style="{
                                backgroundImage:
                                    'url(/images/promo/video_poster.png)',
                            }"
                        >
                            <div
                                class="controls d-flex align-items-center justify-content-center"
                                v-if="!videoClicked"
                                @click="videoClicked = true"
                            >
                                <img
                                    src="/images/promo/play_button.svg"
                                    alt=""
                                />
                                <div class="span">
                                    {{ $t("promo.Awards - fire") }}
                                </div>
                            </div>
                            <iframe
                                v-else
                                width="100%"
                                height="315"
                                src="https://www.youtube.com/embed/m8vj7jqSumQ"
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen
                                autoplay
                            ></iframe>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            videoClicked: false,
        };
    },
};
</script>

<style lang="scss" scoped>
.home {
    &__awards {
        margin: 32px 0px;

        .bg {
            background: #f7f9fc;
            border-radius: 8px;
            padding: 24px 32px;
            @media (max-width: 575px) {
                padding: 20px 15px;
                margin-left: -15px;
                margin-right: -15px;
                border-radius: 0;
            }

            .title {
                font-weight: 600;
                font-size: 18px;
                color: #141430;
                @media (max-width: 1024px) {
                    font-size: 22px;
                }
            }

            p {
                font-weight: normal;
                font-size: 16px;
                line-height: 22px;
                color: #959bb5;
                @media (max-width: 1024px) {
                    font-size: 16px;
                }
            }

            .awards {
                .item {
                    padding: 10px 20px;
                    @media (max-width: 768px) {
                        padding: 10px 30px;
                    }

                    img {
                        height: 85px;
                    }
                }

                margin-bottom: 48px;
                margin-top: 32px;
            }

            .video {
                width: 100%;
                height: 315px;
                background-size: cover;
                background-position: center;

                .controls {
                    font-style: normal;
                    font-weight: 600;
                    font-size: 20px;
                    line-height: 20px;
                    color: #ffffff;
                    cursor: pointer;

                    img {
                        margin-right: 16px;
                    }
                }
            }
        }
    }
}
</style>
